// src/utils/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // Common
      'dashboard': 'الرئيسية',
      'Profile': 'ملفي الشخصي',
      'situationA': 'الوضعية الإدارية',
      'loading': 'جاري التحميل...',
      'error': 'خطأ',
      'success': 'نجح',
      'login': 'تسجيل الدخول',
      'logout': 'تسجيل الخروج',
      'cancel': 'إلغاء',
      'save': 'حفظ',
      'close': 'إغلاق',

      // Sidebar Navigation
      'administrativeSituation': 'الوضعية الإدارية',
      'pedagogicalSituation': 'الوضعية البيداغوجية',
      'officialDocuments': 'كشوفات النقط',
      'gradesAndResults': 'النقط والنتائج',
      'statistics': 'الاحصائيات',
      'diplomaProgress': 'مسار الدبلوم',
      'requestsAndComplaints': 'الشكايات والطلبات',

      // Dashboard Home
      'goodMorning': 'صباح الخير',
      'goodAfternoon': 'مساء الخير',
      'goodEvening': 'مساء الخير',
      'welcomeMessageBody': 'مرحباً بك في تطبيق وضعيتي – المنصة الخاصة بطلبة كلية العلوم القانونية والسياسية بسطات. يمكنك من خلاله الاطلاع على وضعيتك الجامعية، نقاطك، وتتبع مسارك الجامعي بكل سهولة وفي أي وقت.',
      
      // Quick Actions (Home Page)
      'myProfile': 'بياناتي',
      'viewPersonalInfo': 'عرض معلوماتك الشخصية والجامعية',
      'viewModules': 'عرض الوحدات والمواد المسجل بها حسب السنة',
      'viewAdminReg': 'عرض التسجيل الإداري عبر السنوات الجامعية',
      'myGrades': 'نقطي',
      'viewAllGrades': 'عرض جميع نقطك مفصلة حسب السنوات',
      'timeSchedule': 'البرمجة الزمنية',
      'examConvocation': 'استدعاء الامتحان',
      'examResults': 'نتائج الدورة',
      'examResults_subtitle': 'نتائج الدورة الحالية',
      'examResults_notAvailable': 'النتائج غير متاحة بعد',
      'examResults_tryLater': 'يرجى المحاولة لاحقاً بعد الإعلان عن النتائج',
      'examResults_noResults': 'لا توجد نتائج متاحة لهذه الدورة',
      'rattrapageResults_title': 'نتائج الدورة الاستدراكية',
      'rattrapageResults_subtitle': 'نتائج الوحدات التي اجتزتها في الدورة الاستدراكية',
      'rattrapageResults_noResults': 'لم تُعلن بعد نتائج الدورة الاستدراكية',
      'viewSchedule': 'عرض البرمجة الزمنية الخاصة بالدورة',
      'comingSoon': 'هذه الخدمة قيد التطوير',
      
      // Info Summary
      'infoSummary': 'ملخص المعلومات',
      'N Apogee': 'رقم الطالب "أبوجي"',
      'specialization': 'التخصص',
      'cinLabel': 'رقم أبوجي',
      'lastUpdate': 'آخر تحديث',
      'studentSystem': 'منصة وضعيتي',

      // Grades
      'gradesTitle': 'النتائج',
      'gradeStats': 'إحصائيات النقط',
      'filterByYear': 'حسب السنة',
      'filterBySession': 'حسب الدورة',
      'allYears': 'جميع السنوات',
      'allSessions': 'جميع الدورات',
      'sessionType': 'حسب الدورة',
      'autumnSession': 'الدورة الخريفية',
      'springSession': 'الدورة الربيعية',
      'normalSession': 'دورة عادية',
      'catchupSession': 'دورة الاستدراكية',
      'semester': 'السداسي',
      'subject': 'المادة',
      'grade': 'النقطة',
      'result': 'النتيجة',
      'type': 'النوع',
      'module': 'وحدة',
      'passed': 'نجح',
      'failed': 'رسب',
      'absent': 'غائب',
      'total': 'إجمالي',
      'average': 'المعدل',
      'noGrades': 'لا توجد نقط متاحة',
      'selectFilters': 'اختر الفلاتر لعرض النقط',
      
      // Additional Profile translations
      'noData': 'لا توجد بيانات متاحة',
      'refresh': 'تحديث',
      'male': 'ذكر',
      'female': 'أنثى',
      'cycleInscriptions': 'تسجيلات الدورة',
      'stageInscriptions': 'تسجيلات المرحلة',
      'diplomaInscriptions': 'تسجيلات الدبلوم',
      'additionalInfo': 'معلومات إضافية',

      // Login
      'welcome': 'مرحباً بك',
      'enterCin': 'أدخل رقم الطالب أبوجي',
      'enterPassword': 'JJ/MM/AAAA',
      'passwordLabel': 'تاريخ الميلاد',
      'loginButton': 'تسجيل الدخول',
      'loginFailed': 'فشل تسجيل الدخول',
      'invalidCredentials': 'بيانات الدخول غير صحيحة',
      
      // Student Info
      'studentInfo': 'معلومات الطالب',
      'personalInfo': 'المعلومات الشخصية',
      'academicInfo': 'المعلومات الجامعية',
      'grades': 'النقط',
      'studentCode': 'رقم الطالب',
      'fullName': 'الاسم الكامل',
      'arabicName': 'الاسم بالعربية',
      'cin': 'رقم بطاقة التعريف',
      'dateOfBirth': 'تاريخ الميلاد',
      'placeOfBirth': 'مكان الميلاد',
      'gender': 'الجنس',
      'academicYear': 'السنة الجامعية',
      'diploma': 'الدبلوم',

      // Documents
      'transcripts': 'كشوف النقط',
      'generateTranscript': 'إنشاء كشف النقط',
      'selectSemester': 'اختر السداسي',
      'downloadTranscript': 'تحميل كشف النقط',
      'officialTranscript': 'كشف النقط الرسمي',
      'finalGrades': 'النقط النهائية',
      'currentGrades': 'النقط الحالية',
      'academicTranscript': 'كشف الدرجات الأكاديمي',

      'profileTitle': 'ملفي الشخصي',
      'profileDescription': 'معلوماتك الشخصية والجامعية',

      // Administrative Situation
      'as_title': 'الوضعية الإدارية',
      'as_subtitle': 'سجل التسجيلات الجامعية',
      'as_loading': 'جاري تحميل الوضعية الإدارية...',
      'as_errorLoad': 'فشل في تحميل الوضعية الإدارية',
      'as_refresh': 'تحديث',
      'as_yearLabel': 'السنة:',
      'as_allYears': 'جميع السنوات',
      'as_academicYear': 'السنة الجامعية',
      'as_currentYear': 'السنة الحالية',
      'as_nReg': '{{count}} تسجيل',
      'as_certificate': 'شهادة التسجيل',
      'as_primary': 'أساسي',
      'as_active': 'مسجّل',
      'as_inactive': 'غير نشط',
      'as_unknown': 'غير محدد',
      'as_noData': 'لا توجد بيانات متاحة',
      'as_noRegYear': 'لا توجد تسجيلات للسنة {{year}}',
      'as_noRegAll': 'لم يتم العثور على أي تسجيل جامعي',

      // Pedagogical Situation
      'ps_title': 'الوضعية البيداغوجية الحالية',
      'ps_subtitle': 'الوحدات والمواد المسجل بها للموسم الجامعي',
      'ps_loading': 'جاري تحميل الوضعية البيداغوجية...',
      'ps_refresh': 'تحديث',
      'ps_tabYearly': 'السنوي',
      'ps_tabSemester': 'الوحدات',
      'ps_nModules': '{{count}} مادة',
      'ps_semester': 'السداسي',
      'ps_annual': 'النتائج السنوية',
      'ps_unassigned': 'غير محدد',
      'ps_noYearly': 'لا توجد عناصر سنوية',
      'ps_noSemester': 'لا توجد سداسيات',
      'ps_noData': 'لا توجد وضعية بيداغوجية',
      'ps_noDataDesc': 'لا توجد بيانات مسجلة حالياً',
      'ps_level1A': 'السنة الأولى',
      'ps_level2A': 'السنة الثانية',
      'ps_level3A': 'السنة الثالثة',
      'ps_level4A': 'السنة الرابعة',
      'ps_level5A': 'السنة الخامسة',
      'ps_group': 'المجموعة',

      // Grades page
      'grades_title': 'النقط والنتائج',
      'grades_subtitle': 'نتائجك الجامعية مرتبة حسب السنة والدورة',
      'grades_loading': 'جاري تحميل النقط...',
      'grades_errorLoad': 'فشل في تحميل النقط',
      'grades_selectPrompt': 'اختر السنة و الدورة ',
      'grades_selectHint': 'اتبع الخطوات الثلاث في الفلتر أعلاه',
      'grades_noResults': 'لا توجد نقط  ',

      // Grade Filters
      'gf_title': 'فلترة النقط',
      'gf_clear': 'مسح الاختيارات',
      'gf_activeFilters': 'الاختيارات ',
      'gf_step1': 'الخطوة 1 — ابدأ هنا',
      'gf_step2': 'الخطوة 2',
      'gf_step3': 'الخطوة 3',
      'gf_selectYear': 'اختر السنة أولاً',
      'gf_selectType': 'اختر نوع الدورة أولاً',
      
      'gf_sessionLabel': 'الدورة',
      'gf_all': 'الكل',

      // Grade Table
      'gt_academicYear': 'السنة الجامعية',
      'gt_semester': 'السداسي',
      'gt_autumn': 'الدورة الخريفية',
      'gt_spring': 'الدورة الربيعية',
      'gt_nModules': '{{count}} مادة',
      'gt_legendTitle': 'شرح رموز النتائج',
      'gt_V':   'مستوفي',
      'gt_NV':  'راسب',
      'gt_VAR': 'مستوفي بعد الاستدراك',
      'gt_ACR': 'مستوفي بالتعويض',
      'gt_AC':  'مكتسب بالتعويض',
      'gt_AB':  'غائب',
      'gt_passed': 'ناجح',
      'gt_failed': 'راسب',
      'gt_avg': 'المعدل',
      'gt_passRate': 'نسبة النجاح',
      'gt_moduleName': 'المادة',
      'gt_code': 'الرمز',
      'gt_grade': 'النقطة',
      'gt_result': 'النتيجة',
      'gt_passedIcon': 'ناجح',
      'gt_failedIcon': 'راسب',
      'gt_modulesPassedOf': 'مادة مستوفاة',

      // Grade Reclamations
      'recl_button': 'تقديم شكاية',
      'recl_status_pending': 'قيد المراجعة',
      'recl_status_in_progress': 'قيد المعالجة',
      'recl_status_resolved': 'تمت المعالجة',
      'recl_status_rejected': 'مرفوضة',
      'recl_dialogTitle': 'تقديم شكاية بخصوص النقطة',
      'recl_subjectPrefix': 'شكاية بخصوص نقطة المادة:',
      'optional': 'اختياري',
      'recl_reasonLabel': 'سبب الشكاية',
      'recl_reasonPlaceholder': 'اشرح سبب طعنك في هذه النقطة...',
      'recl_reasonRequired': 'يرجى كتابة سبب الشكاية',
      'recl_submit': 'إرسال',
      'recl_cancel': 'إلغاء',
      'recl_submitError': 'حدث خطأ أثناء إرسال الشكاية',

      // Diploma Progress
      'dp_title': 'مسار الدبلوم',
      'dp_subtitle': 'تتبع تقدمك نحو الحصول على الدبلوم',
      'dp_loading': 'جاري تحميل مسار الدبلوم...',
      'dp_error': 'فشل في تحميل بيانات الدبلوم',
      'dp_roadmap': 'خريطة الدبلوم',
      'dp_years': '{{count}} سنوات',
      'dp_year1': 'السنة الأولى',
      'dp_year2': 'السنة الثانية',
      'dp_year3': 'السنة الثالثة',
      'dp_year4': 'السنة الرابعة',
      'dp_year5': 'السنة الخامسة',
      'dp_year_generic': 'السنة',
      'dp_notStarted': 'لم يبدأ بعد',
      'dp_overallProgress': 'التقدم العام في الدبلوم',
      'dp_unitsAcquired': '{{validated}} / {{total}} وحدة مكتسبة',
      'dp_congrats': 'تهانينا! اكتملت جميع الوحدات',
      'dp_remainingMsg': '{{count}} وحدة متبقية لإتمام الدبلوم',
      'dp_semAutumn': 'الفصل الخريفي',
      'dp_semSpring': 'الفصل الربيعي',
      'dp_semester': 'السداسي',
      'dp_noData': 'لا توجد بيانات متاحة',
      'dp_noDataDesc': 'لا توجد وحدات مسجلة في مسار الدبلوم',
      'dp_legendTitle': 'شرح رموز الاكتساب'
    }
  },
  fr: {
    translation: {
      // Common
      'dashboard': 'Tableau de bord',
      'Profile': 'Mon Profil',
      'situationA': 'Situation Administrative',
      'loading': 'Chargement...',
      'error': 'Erreur',
      'success': 'Succès',
      'login': 'Connexion',
      'logout': 'Déconnexion',
      'cancel': 'Annuler',
      'save': 'Enregistrer',
      'close': 'Fermer',

      // Sidebar Navigation
      'administrativeSituation': 'Situation Administrative',
      'pedagogicalSituation': 'Situation Pédagogique',
      'officialDocuments': 'Documents Officiels',
      'gradesAndResults': 'Notes et Résultats',
      'statistics': 'Statistiques',
      'diplomaProgress': 'Parcours Diplôme',
      'requestsAndComplaints': 'Demandes et Réclamations',

      // Dashboard Home
      'goodMorning': 'Bonjour',
      'goodAfternoon': 'Bon après-midi',
      'goodEvening': 'Bonsoir',
      'welcomeMessageBody': 'Bienvenue sur l\'application Wadiyati - La plateforme dédiée aux étudiants de la FSJES Settat. Vous pouvez consulter votre situation académique, vos notes et suivre votre parcours universitaire facilement et à tout moment.',

      // Quick Actions (Home Page)
      'myProfile': 'Mon Profil',
      'viewPersonalInfo': 'Consulter vos informations personnelles et académiques',
      'viewModules': 'Consulter les modules et matières inscrits par année',
      'viewAdminReg': 'Consulter l\'inscription administrative par année',
      'myGrades': 'Mes Notes',
      'viewAllGrades': 'Consulter toutes vos notes détaillées par année',
      'timeSchedule': 'Emploi du temps',
      'examConvocation': "Convocation d'examen",
      'examResults': 'Résultats de session',
      'examResults_subtitle': 'Résultats de la session courante',
      'examResults_notAvailable': 'Les résultats ne sont pas encore disponibles',
      'examResults_tryLater': 'Veuillez réessayer après la publication des résultats',
      'examResults_noResults': 'Aucun résultat disponible pour cette session',
      'rattrapageResults_title': 'Résultats de la session de rattrapage',
      'rattrapageResults_subtitle': 'Résultats des modules passés en rattrapage',
      'rattrapageResults_noResults': 'Les résultats de la session de rattrapage ne sont pas encore publiés',
      'comingSoon': 'Ce service est en cours de développement',
      'viewSchedule': 'Consulter l\'emploi du temps de la session',

      // Info Summary
      'infoSummary': 'Résumé des Informations',
      'N Apogee': 'Code Apogée',
      'specialization': 'Filière',
      'cinLabel': 'N° CIN',
      'lastUpdate': 'Dernière mise à jour',
      'studentSystem': 'Système d\'Information des Étudiants',

      // Grades
      'gradesTitle': 'Notes Détaillées',
      'gradeStats': 'Statistiques des Notes',
      'filterByYear': 'Filtrer par Année',
      'filterBySession': 'Filtrer par Session',
      'allYears': 'Toutes les Années',
      'allSessions': 'Toutes les Sessions',
      'sessionType': 'Type de Session',
      'autumnSession': 'Session d\'Automne',
      'springSession': 'Session de Printemps',
      'normalSession': 'Session Normale',
      'catchupSession': 'Session de Rattrapage',
      'semester': 'Semestre',
      'subject': 'Matière',
      'grade': 'Note',
      'result': 'Résultat',
      'type': 'Type',
      'module': 'Module',
      'passed': 'Réussi',
      'failed': 'Échoué',
      'absent': 'Absent',
      'total': 'Total',
      'average': 'Moyenne',
      'noGrades': 'Aucune note disponible',
      'selectFilters': 'Sélectionnez les filtres pour afficher les notes',
      
      // Additional Profile translations
      'noData': 'Aucune donnée disponible',
      'refresh': 'Actualiser',
      'male': 'Masculin',
      'female': 'Féminin',
      'cycleInscriptions': 'Inscriptions cycle',
      'stageInscriptions': 'Inscriptions étape',
      'diplomaInscriptions': 'Inscriptions diplôme',
      'additionalInfo': 'Informations supplémentaires',

      // Login
      'welcome': 'Bienvenue',
      'enterCin': 'Entrez votre numéro Apogée',
      'enterPassword': 'JJ/MM/AAAA',
      'passwordLabel': 'Date de naissance',
      'loginButton': 'Se connecter',
      'loginFailed': 'Échec de la connexion',
      'invalidCredentials': 'Identifiants invalides',
      
      // Student Info
      'studentInfo': 'Informations Étudiant',
      'personalInfo': 'Informations Personnelles',
      'academicInfo': 'Informations Académiques',
      'grades': 'Notes',
      'studentCode': 'Code Étudiant',
      'fullName': 'Nom Complet',
      'arabicName': 'Nom en Arabe',
      'cin': 'CIN',
      'dateOfBirth': 'Date de Naissance',
      'placeOfBirth': 'Lieu de Naissance',
      'gender': 'Sexe',
      'academicYear': 'Année Universitaire',
      'diploma': 'Diplôme',
      'profileTitle': 'Mon Profil',
      'profileDescription': 'Vos informations personnelles et universitaires',

       // Documents
      'transcripts': 'Relevés de Notes',
      'generateTranscript': 'Générer Relevé de Notes',
      'selectSemester': 'Sélectionner le Semestre',
      'downloadTranscript': 'Télécharger Relevé de Notes',
      'officialTranscript': 'Relevé de Notes Officiel',
      'finalGrades': 'Notes Finales',
      'currentGrades': 'Notes Actuelles',
      'academicTranscript': 'Relevé Académique',

      // Administrative Situation
      'as_title': 'Situation Administrative',
      'as_subtitle': 'Historique des inscriptions universitaires',
      'as_loading': 'Chargement de la situation administrative...',
      'as_errorLoad': 'Échec du chargement de la situation administrative',
      'as_refresh': 'Actualiser',
      'as_yearLabel': 'Année :',
      'as_allYears': 'Toutes les années',
      'as_academicYear': 'Année universitaire',
      'as_currentYear': 'Année en cours',
      'as_nReg': '{{count}} inscription(s)',
      'as_certificate': "Attestation d'inscription",
      'as_primary': 'Principal',
      'as_active': 'Inscrit',
      'as_inactive': 'Inactif',
      'as_unknown': 'Non défini',
      'as_noData': 'Aucune donnée disponible',
      'as_noRegYear': "Aucune inscription pour l'année {{year}}",
      'as_noRegAll': 'Aucune inscription universitaire trouvée',

      // Pedagogical Situation
      'ps_title': 'Situation Pédagogique Actuelle',
      'ps_subtitle': "Modules et matières inscrits pour l'année universitaire",
      'ps_loading': 'Chargement de la situation pédagogique...',
      'ps_refresh': 'Actualiser',
      'ps_tabYearly': 'Annuel',
      'ps_tabSemester': 'Semestres',
      'ps_nModules': '{{count}} matière(s)',
      'ps_semester': 'Semestre',
      'ps_annual': 'Résultats Annuels',
      'ps_unassigned': 'Non assigné',
      'ps_noYearly': 'Aucun élément annuel',
      'ps_noSemester': 'Aucun semestre',
      'ps_noData': 'Aucune situation pédagogique',
      'ps_noDataDesc': 'Aucune donnée enregistrée actuellement',
      'ps_level1A': '1ère Année',
      'ps_level2A': '2ème Année',
      'ps_level3A': '3ème Année',
      'ps_level4A': '4ème Année',
      'ps_level5A': '5ème Année',
      'ps_group': 'Groupe',

      // Grades page
      'grades_title': 'Notes et Résultats',
      'grades_subtitle': 'Vos résultats universitaires par année et session',
      'grades_loading': 'Chargement des notes...',
      'grades_errorLoad': 'Échec du chargement des notes',
      'grades_selectPrompt': 'Sélectionnez l\'année, le type de session et la session',
      'grades_selectHint': 'Suivez les 3 étapes du filtre ci-dessus',
      'grades_noResults': 'Aucune note pour les filtres sélectionnés',

      // Grade Filters
      'gf_title': 'Filtrer les notes',
      'gf_clear': 'Effacer les filtres',
      'gf_activeFilters': 'Filtres actifs',
      'gf_step1': 'Étape 1 — Commencez ici',
      'gf_step2': 'Étape 2',
      'gf_step3': 'Étape 3',
      'gf_selectYear': 'Sélectionnez l\'année d\'abord',
      'gf_selectType': 'Sélectionnez le type de session d\'abord',
      'gf_sessionLabel': 'Session',
      'gf_all': 'Tous',

      // Grade Table
      'gt_academicYear': 'Année Universitaire',
      'gt_semester': 'Semestre',
      'gt_autumn': 'Session d\'Automne',
      'gt_spring': 'Session de Printemps',
      'gt_nModules': '{{count}} matière(s)',
      'gt_legendTitle': 'Explication des codes de résultat',
      'gt_V':   'Validé',
      'gt_NV':  'Non validé',
      'gt_VAR': 'Validé après rattrapage',
      'gt_ACR': 'Acquis par compensation',
      'gt_AC':  'Acquis par compensation',
      'gt_AB':  'Absent',
      'gt_passed': 'Reçu',
      'gt_failed': 'Échoué',
      'gt_avg': 'Moyenne',
      'gt_passRate': 'taux de réussite',
      'gt_moduleName': 'Matière',
      'gt_code': 'Code',
      'gt_grade': 'Note',
      'gt_result': 'Résultat',
      'gt_passedIcon': 'Réussi',
      'gt_failedIcon': 'Échoué',
      'gt_modulesPassedOf': 'matière(s) validée(s)',

      // Grade Reclamations
      'recl_button': 'Réclamer',
      'recl_status_pending': 'En attente',
      'recl_status_in_progress': 'En cours',
      'recl_status_resolved': 'Traitée',
      'recl_status_rejected': 'Rejetée',
      'recl_dialogTitle': 'Réclamation de note',
      'recl_subjectPrefix': 'Réclamation concernant la note du module :',
      'optional': 'facultatif',
      'recl_reasonLabel': 'Motif de la réclamation',
      'recl_reasonPlaceholder': 'Expliquez pourquoi vous contestez cette note...',
      'recl_reasonRequired': 'Veuillez indiquer le motif de la réclamation',
      'recl_submit': 'Envoyer',
      'recl_cancel': 'Annuler',
      'recl_submitError': 'Une erreur est survenue lors de l\'envoi de la réclamation',

      // Diploma Progress
      'dp_title': 'Parcours Diplôme',
      'dp_subtitle': 'Suivez votre progression vers l\'obtention du diplôme',
      'dp_loading': 'Chargement du parcours diplôme...',
      'dp_error': 'Échec du chargement des données du diplôme',
      'dp_roadmap': 'Carte du parcours',
      'dp_years': '{{count}} ans',
      'dp_year1': '1ère Année',
      'dp_year2': '2ème Année',
      'dp_year3': '3ème Année',
      'dp_year4': '4ème Année',
      'dp_year5': '5ème Année',
      'dp_year_generic': 'Année',
      'dp_notStarted': 'Pas encore commencé',
      'dp_overallProgress': 'Progression globale du diplôme',
      'dp_unitsAcquired': '{{validated}} / {{total}} unité(s) acquise(s)',
      'dp_congrats': 'Félicitations ! Toutes les unités sont validées',
      'dp_remainingMsg': '{{count}} unité(s) restante(s) pour terminer le diplôme',
      'dp_semAutumn': 'Semestre d\'Automne',
      'dp_semSpring': 'Semestre de Printemps',
      'dp_semester': 'Semestre',
      'dp_noData': 'Aucune donnée disponible',
      'dp_noDataDesc': 'Aucune unité enregistrée dans le parcours diplôme',
      'dp_legendTitle': 'Explication des codes d\'acquisition'
    }
  }
};

const savedLang = localStorage.getItem('language') || 'ar';
const savedDir = savedLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.dir = savedDir;
document.documentElement.lang = savedLang;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Always keep document direction in sync with language
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
  if (document.body) document.body.dir = dir;
});

// Apply body dir on initial load (body is available since scripts are deferred)
if (document.body) document.body.dir = savedDir;

export default i18n;